import React from "react";
import { destroyFrame, uploadFrame } from "src/actions/mine_craft/framesActions";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setNewGroupParams } from "src/store/mine_craft/framesSlice";

import DrawerRight from "src/componets/DrawerRight";
import GroupUpload from "src/componets/FileDropzone/GroupUpload";
import mineCraftApi from "src/api/mineCraftApi";
import { Form, InputNumber, message, Radio, RadioChangeEvent } from "antd";
import { DollarOutlined } from "@ant-design/icons";

const Dropzone = () => {
  const dispatch = useAppDispatch();
  const newGroupParams = useAppSelector(state => state.mineCraft.frames.newGroupParams);
  const data: any = {
    app_id: newGroupParams?.app_id,
    frame_type: newGroupParams?.frame_type,
    coins: newGroupParams?.coins || 0,
  };

  const onChangeUploadFrameType = (e: RadioChangeEvent) => {
    dispatch(setNewGroupParams({ ...newGroupParams, frame_type: e.target.value }));
  };

  const onChangeCoins = (value: number | null) => {
    dispatch(setNewGroupParams({ ...newGroupParams, coins: value || 0 }));
  }

  function onClose() {
    dispatch(setNewGroupParams(null));
  }

  function handleUploadSuccess(response: any) {
    dispatch(uploadFrame(response));
  }

  function onClickDestroy(file: any) {
    const id = file.response?.frame?.id;
    if (id) {
      handleDestroy(id).catch(console.error);
    }
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyFrame(id));

    if (destroyFrame.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
    }

    if (destroyFrame.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <DrawerRight
      open={!!newGroupParams}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-newGroup-frame'>
        <h6 className="v-content-label">Frames Dropzone</h6>

        <GroupUpload
          name='image'
          action={mineCraftApi.oneSky.url('/onesky/frames')}
          headers={mineCraftApi.oneSky.uploadHeaders}
          data={data}
          onSuccess={handleUploadSuccess}
          listType='picture'
          onRemove={onClickDestroy}
        />

        <h6 className="v-content-label o-sm v-mb-15 v-mt-15">Frame Type</h6>
        <Radio.Group
          onChange={onChangeUploadFrameType}
          value={newGroupParams?.frame_type || 'static'}
        >
          <Radio value='static'>Static</Radio>
          <Radio value='animated'>Animated</Radio>
        </Radio.Group>

        <h6 className="v-content-label o-sm v-mb-15 v-mt-15">Coins</h6>
        <Form.Item name='coins'>
          <InputNumber
            min={0}
            step={5}
            placeholder='0'
            style={{ width: '100%' }}
            prefix={<DollarOutlined />}
            onChange={onChangeCoins}
            size='large'
          />
        </Form.Item>

      </div>
    </DrawerRight>
  )
}

export default Dropzone;
